// @ts-nocheck

import * as Types from '../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type GetDailyBriefingQueryVariables = Types.Exact<{
  request?: Types.InputMaybe<Types.DailyBriefingRequestModelInput>;
}>;

export type GetDailyBriefingQuery = {
  dailyBriefing: {
    summary?: string | null;
    actionItems?: Array<{
      rank: number;
      title?: string | null;
      explanation?: string | null;
      recommendedAction?: string | null;
      category?: Types.BriefingItemCategory | null;
      severity?: Types.BriefingSeverity | null;
      missingInformation?: Array<string | null> | null;
      waitingOnParties?: Array<Types.ResponsibleParty | null> | null;
      waitingOnRoles?: Array<string | null> | null;
      references?: Array<{
        type?: Types.BriefingReferenceType | null;
        uid: string;
        personUid?: string | null;
      } | null> | null;
    } | null> | null;
  };
};

export const GetDailyBriefingDocument = gql`
    query GetDailyBriefing($request: DailyBriefingRequestModelInput) {
  dailyBriefing(request: $request) {
    summary
    actionItems {
      rank
      title
      explanation
      recommendedAction
      category
      severity
      references {
        type
        uid
        personUid
      }
      missingInformation
      waitingOnParties
      waitingOnRoles
    }
  }
}
    ` as unknown as DocumentNode<GetDailyBriefingQuery, GetDailyBriefingQueryVariables>;
